import React, { useEffect, useState, useRef } from "react";
import { useLocation } from "react-router-dom";
import styles from "./Navbar.module.css";
import logo1x from "../assets/logo@1x.png";
import logo2x from "../assets/logo@2x.png";
import logo3x from "../assets/logo@3x.png";


type Mode = "top" | "compact";
const TOP_THRESHOLD_VH = 0.22;

export default function Navbar() {
  const { pathname } = useLocation();
  const [mode, setMode] = useState<Mode>("top");
  const [ready, setReady] = useState(false);

  const observerRef = useRef<IntersectionObserver | null>(null);

  const waitingRef = useRef<number | null>(null);

  const waitForNavGuard = (cb: (el: HTMLElement) => void) => {
    const attempt = () => {
      const el = document.getElementById("nav-guard");
      if (el) {
        cb(el);
        return;
      }
      waitingRef.current = requestAnimationFrame(attempt);
    };
    attempt();
  };

  useEffect(() => {
    const atTop = window.scrollY <= 1;
    const onHome = pathname === "/";
    setMode(onHome && atTop ? "top" : "compact");

    const t = setTimeout(() => setReady(true), 30);
    return () => clearTimeout(t);
  }, []);

  useEffect(() => {
    if (pathname === "/") setMode("top");
    else setMode("compact");
  }, [pathname]);



  useEffect(() => {
    if (observerRef.current) observerRef.current.disconnect();
    if (waitingRef.current) cancelAnimationFrame(waitingRef.current);

    if (pathname !== "/") return;

    const isSmall = window.matchMedia("(max-width: 500px)").matches;

    if (isSmall) {
      const sync = () => setMode(window.scrollY <= 1 ? "top" : "compact");
      sync(); 
      window.addEventListener("scroll", sync, { passive: true });
      return () => window.removeEventListener("scroll", sync);
    }

    waitForNavGuard((guard) => {
      const thresholds = Array.from({ length: 20 }, (_, i) => i / 20);
      const thr = 1 - TOP_THRESHOLD_VH;

      observerRef.current = new IntersectionObserver(
        (entries) => {
          const ratio = entries[0]?.intersectionRatio ?? 1;
          setMode(ratio <= thr ? "compact" : "top");
        },
        { threshold: thresholds }
      );

      observerRef.current.observe(guard);
    });

    return () => {
      if (waitingRef.current) cancelAnimationFrame(waitingRef.current);
      if (observerRef.current) observerRef.current.disconnect();
    };
  }, [pathname]);


  const navH = mode === "top" ? 112 : 70;

  return (
    <header
      className={[
        styles.navbar,
        ready ? styles.ready : styles.boot,
        styles[mode],
      ].join(" ")}
      role="banner"
      aria-label="Hauptnavigation"
      style={{ ["--nav-h" as any]: `${navH}px` }}
    >
      <div className={styles.inner}>
        <a
          href="/"
          className={styles.brand}
          aria-label="Dr. Fernando International – Startseite"
        >
       <img
  src={logo1x}
  srcSet={`${logo1x} 1x, ${logo2x} 2x, ${logo3x} 3x`}
  alt=""
  className={styles.logo}
/>

          <span className={styles.wordmark}>
            DR.&nbsp;FERNANDO&nbsp;<b>INTERNATIONAL</b>
          </span>
          <i className={styles.sigLine} aria-hidden="true" />
        </a>
      </div>
    </header>
  );
}
